// extracted by mini-css-extract-plugin
module.exports = {"form":"admin-portal__Form__form","widgetWrap":"admin-portal__Form__widgetWrap","checkbox":"admin-portal__Form__checkbox","buttonBar":"admin-portal__Form__buttonBar"};